import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Typography
} from "@material-ui/core";
import SearchableSelect from "../../components/SearchableSelect";
import React, {useState} from "react";
import {ProductOrigin, RoleIdEnum} from "../../generated/graphql";
import UploadFile from "../order/UploadFile";
import {format} from "date-fns";
import {HasRole} from "../../common/Util";

export default () => {
    const [open, setOpen] = useState(false);
    const [productOrigin, setProductOrigin] = useState<ProductOrigin>(ProductOrigin.Google)
    const [missingAccountCosts, setMissingAccountCosts] = useState([])
    return <div>
        <Dialog open={open} fullWidth={true}>
            <DialogTitle style={{backgroundColor: "#DDD"}}>
                <Typography variant="h4" align="center">
                    上傳每日花費
                </Typography>
            </DialogTitle>
            <DialogContent>
                <FormControl required style={{width: "100%", marginBottom: 10}}>
                    <SearchableSelect
                        label={"媒體"}
                        required
                        disableClearable
                        options={[
                            {value: "google", label: "Google"},
                            {value: "facebook", label: "Meta"},
                            {value: "line", label: "LINE"},
                            {value: "yahoo", label: "Yahoo"},
                        ]}
                        value={productOrigin}
                        onChange={(value) => {
                            setProductOrigin(value as ProductOrigin);
                        }}
                    />
                </FormControl>
                <UploadFile
                    uploadTitle={"上傳花費Excel"}
                    uriPart={`/account-costs/import-product-origin-costs?productOrigin=${productOrigin}`}
                    onSuccess={(result)=>{
                        setMissingAccountCosts(result.missingAccountCosts);
                    }}
                />
                {(missingAccountCosts.length>0) && <>無發稿CID:<br/><div>
                {missingAccountCosts.map((accountCost: any)=>{
                    return <div>{`${accountCost.name} ${format(new Date(accountCost.date), "yyyy-MM-dd")} ${accountCost.accountId} ${accountCost.cost}`}</div>;
                })}</div></>}

            </DialogContent>
            <DialogActions>
                <Button
                    variant={"contained"}
                    color={"secondary"}
                    onClick={()=>{
                        setMissingAccountCosts([]);
                        setOpen(false);
                    }}>
                    取消
                </Button>
            </DialogActions>
        </Dialog>
        <HasRole roles={[RoleIdEnum.Admin]}>
            <Button
                variant={"contained"}
                color={"primary"}
                onClick={() => setOpen(true)}
            >
                上傳每日花費
            </Button>
        </HasRole>
    </div>
}